<template>
    <el-card shadow="never">

        <div slot="header" class="clearfix">
            <span>{{ $t('reset_password_title') }}</span>
        </div>

        <el-form :model="model" status-icon label-width="120px" label-position="top">

            <el-form-item :label="$t('new_password')" prop="password" :error="error.password">
                <el-input v-model="model.password"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="reset()" :loading="loading_form">{{ $t('reset_password_button') }}</el-button>
                <router-link :to="{name: 'login'}" tag="el-button">
                    {{ $t('cancel') }}
                </router-link>
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
    export default {
        name: "ResetPassword",
        data () {
            return {
                model: {
                    password: ''
                },
                error: {},
                loading_form: false
            }
        },
        methods: {
            reset () {
                this.loading_form = true;
                this.$axios.post('/reset-password?token=' + this.$route.query.token, this.model).then(() => {
                    this.$router.replace({ path: '/main' });
                    this.$message.success(this.$t('notice.reset_password_success'));
                    this.error = {};
                    this.loading_form = false;
                }).catch((error) => {
                    this.error = error.response.data;
                    this.loading_form=false;
                });

            }
        }
    }
</script>

<style lang="scss" scoped>
    .el-card {
        margin-left: auto;
        margin-right: auto;
        width: 400px;
        .el-alert {
            margin-top:10px;
        }
    }
</style>